module.exports = __webpack_public_path__ + "static/proxsure-pic-d8d5d92869cada8098af8cf7a4cc0397.png";